<template>
  <div>
    <div class="mt-3 vx-row">
      <header class="w-full mb-4 vx-col sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
        <h4>{{ $t("tracks.export-tracks-csv.title") }}</h4>
        <p>{{ $t("tracks.export-tracks-csv.subtitle") }}</p>
      </header>
    </div>
    <div>
      <ExportForm :buttonText="$t('tracks.export-tracks-csv.export-tracks')" @exportData="exportData" />
    </div>
  </div>
</template>

<script>

import ExportForm from '@/modules/Shared/Components/form/ExportForm'
import notifications from "@/modules/Shared/Mixins/notifications";
import loader from "@/modules/Shared/Mixins/loader";

export default {
  name: 'tracks-export-page',
  components: {
    ExportForm
  },
  props: {
    exportTracksFunction: {
      type: Function,
      required: true
    },
    tracksListRouteName: {
      type: String,
      required: true
    }
  },
  mixins: [ notifications, loader ],
  methods: {
    async exportData(params) {
      await this.load(async () => {
        await this.exportTracksFunction(this.$route.params.uuid, {...params, type: 'csv' })
      })

      this.notifySuccess(null, this.$t('apps.photos.exportsent', { email: params.email }))
      this.$router.push({ name: this.tracksListRouteName, params: { uuid: this.$route.params.uuid } });
    }
  }
}
</script>
